/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Invitation_RevokedInputs */

const fr_error_invitation_revoked = /** @type {(inputs: Error_Invitation_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce lien a été annulé. Demandez-en un nouveau à un administrateur.`)
};

const en_error_invitation_revoked = /** @type {(inputs: Error_Invitation_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This link has been cancelled. Ask an administrator for a new one.`)
};

/**
* | output |
* | --- |
* | "This link has been cancelled. Ask an administrator for a new one." |
*
* @param {Error_Invitation_RevokedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_invitation_revoked = /** @type {((inputs?: Error_Invitation_RevokedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Invitation_RevokedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_invitation_revoked(inputs)
	return fr_error_invitation_revoked(inputs)
});